import { render, staticRenderFns } from "./ProjSelect.vue?vue&type=template&id=1f0b7833&scoped=true&"
import script from "./ProjSelect.vue?vue&type=script&lang=js&"
export * from "./ProjSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProjSelect.vue?vue&type=style&index=0&id=1f0b7833&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b7833",
  null
  
)

export default component.exports